import AdvancedDataTable from 'Components/Generic/AdvancedDataTable';
import DataTableHeaderTextFieldFilter from 'Components/Generic/AdvancedDataTable/DataTableHeaderTextFieldFilter';
import { TEXT_FILTER_MAP } from 'Components/Generic/AdvancedDataTable/Helper';
import { showSaveSuccessToast } from 'Components/Generic/BOSToasterUtil';
import AddNewButton from 'Components/Generic/Buttons/AddNewButton';
import QuickViewButton from 'Components/Generic/Buttons/QuickViewButton';
import ExpenseCodeDrawerButton from 'Components/SiteDrawerContainer/ExpenseCodeDrawerButton';
import { SITE_PAGES } from 'Config';
import ExpenseCodeData from 'Data/ExpenseCodeData';
import SiteDrawerData from 'Data/SiteDrawerData';
import DataManager from 'Lib/DataManager';
import { usePersistentFiltering } from 'Lib/hooks/usePersistentFiltering';
import { useEffect, useState } from 'react';
import AccountLanding from '../AccountLanding';
import ExpenseCodeDetails from '../ExpenseCodes/ExpenseCodeDetails';

let DM = new DataManager();

let filterOptions = {
  abr_code_fk: {
    seqRestKey: `*$abr_codes.abr_code,description`,
    mapToSeqRestValue: TEXT_FILTER_MAP,
  },
  expense_code: {
    seqRestKey: '*expense_code',
    mapToSeqRestValue: TEXT_FILTER_MAP,
  },
  description: {
    seqRestKey: '*description',
    mapToSeqRestValue: TEXT_FILTER_MAP,
  },
};

const ExpenseCodeListView = () => {
  const [data, setData] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [persistentFilter, updateFilterField] =
    usePersistentFiltering(`EC_FILTER`);

  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: 'New Expense Code',
    });
  };

  let addNewButton = (
    <AddNewButton
      buttonText='Add Expense Code'
      clickHandler={onClick}
      tableButton
    />
  );

  useEffect(() => {
    DM.add(
      ExpenseCodeData.registerListener('RECORD_CREATED', onExpenseCodeCreated),
      ExpenseCodeData,
    );
    DM.add(
      ExpenseCodeData.registerListener('RECORD_UPDATED', refreshAndCloseDrawer),
      ExpenseCodeData,
    );
    DM.add(
      ExpenseCodeData.registerListener('LIST_LOADED', setData),
      ExpenseCodeData,
    );
    DM.add(
      ExpenseCodeData.registerListener(
        'LIST_LOAD_ERROR',
        onExpenseCodeListLoadError,
      ),
      ExpenseCodeData,
    );
    DM.add(
      ExpenseCodeData.registerListener(
        'RECORDS_DELETED',
        refreshAndCloseDrawer,
      ),
      ExpenseCodeData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  const onExpenseCodeListLoadError = () => {};

  const onExpenseCodeCreated = (payload) => {
    if (payload) {
      showSaveSuccessToast('Expense Code Created');
      refreshAndCloseDrawer();
    }
  };

  const refreshAndCloseDrawer = () => {
    setRefreshKey((prevState) => prevState + 1);
    SiteDrawerData.close();
  };

  const headers = [
    {
      label: 'ABR',
      value: 'abr_code_fk',
      width: 240,
      sortable: true,
      filterable: true,
      renderHeader() {
        return (
          <DataTableHeaderTextFieldFilter
            fieldName={'ABR'}
            defaultValue={persistentFilter?.abr_code_fk}
            onFilterValueUpdate={(e) =>
              updateFilterField('abr_code_fk', e.target.value)
            }
          />
        );
      },
      render: (ec) => {
        return (
          (ec?.abr_code &&
            `${ec.abr_code.abr_code}: ${ec.abr_code.description}`) ||
          ec.abr_code_fk
        );
      },
    },
    {
      label: 'Expense Code',
      value: 'expense_code',
      width: 180,
      sortable: true,
      filterable: true,
      renderHeader() {
        return (
          <DataTableHeaderTextFieldFilter
            fieldName={'Expense Code'}
            defaultValue={persistentFilter?.expense_code}
            onFilterValueUpdate={(e) =>
              updateFilterField('expense_code', e.target.value)
            }
          />
        );
      },
    },
    {
      label: 'Range Start',
      value: 'serial_range_start',
      width: 180,
      sortable: true,
    },
    {
      label: 'Range End',
      value: 'serial_range_end',
      width: 180,
      sortable: true,
    },
    {
      label: 'Description',
      value: 'description',
      sortable: true,
      filterable: true,
      renderHeader() {
        return (
          <DataTableHeaderTextFieldFilter
            fieldName={'Description'}
            defaultValue={persistentFilter?.description}
            onFilterValueUpdate={(e) =>
              updateFilterField('description', e.target.value)
            }
          />
        );
      },
    },
    {
      label: '',
      value: 'quick_view',
      isIconCol: true,
      render(ec) {
        return (
          <ExpenseCodeDrawerButton
            expenseCodeId={ec.id}
            drawerTitle={ec.description}
            label={<QuickViewButton />}
          />
        );
      },
    },
  ];

  let drawerContent = (
    <ExpenseCodeDetails hideToggle editable parentEditState={true} />
  );

  let breadcrumb = [SITE_PAGES.EXPENSE_CODE];

  let pageContent = (
    <AdvancedDataTable
      headers={headers}
      refreshKey={refreshKey}
      title={'Expense Codes'}
      dataKey={'EC'}
      data={data}
      dataQueryFunc={ExpenseCodeData.getECRecordList}
      filterOptions={filterOptions}
      filterBy={persistentFilter}
      updateFilterField={updateFilterField}
      defaultSort={'abr_code_fk'}
      actionButtons={addNewButton}
    />
  );

  return (
    <AccountLanding breadcrumbs={breadcrumb}>{pageContent}</AccountLanding>
  );
};

export default ExpenseCodeListView;
